<template>
	<div class="bank-page">
		<van-nav-bar :title="$t('setting.bank_info')" fixed placeholder class="custom-nav">
			<template #left>
				<van-icon name="arrow-left" size="20" color="#fff" @click="back" />
			</template>
		</van-nav-bar>

		<div class="wrapper">

			<div class="bank-list">
				<div v-for="(card, index) in bankInfo" :key="index" class="bank-card-view" :class="{'crypto-card': isCryptoCard(card)}">
					<div class="card-pattern"></div>

					<div class="card-content">
						<div class="card-header">
							<div class="bank-logo">
								<van-icon :name="isCryptoCard(card) ? 'gold-coin' : 'card'" />
							</div>
							<div class="bank-info">
								<div class="bank-name">{{ card.bankinfo }}</div>
<!--								<div class="card-type">{{ isCryptoCard(card) ? 'Crypto Wallet' : 'Debit Card' }}</div>-->
							</div>
						</div>

						<div class="card-fields">
							<div v-for="(value, key) in card" :key="key" class="field-item">
								<template v-if="key !== 'bankinfo' && !isExcludedField(key)">
									<span class="field-label">{{ getFieldLabel(card) }}</span>
									<span class="field-value">{{ formatFieldValue(key, value) }}</span>
								</template>
							</div>
						</div>

<!--						<div class="card-footer">
							<div class="holder-info">
								<span class="label">{{ $t('setting.username') }}</span>
								<span class="name">{{ userInfo.name }}</span>
							</div>
							<div class="chip">
								<span></span><span></span><span></span>
							</div>
						</div>-->
					</div>
				</div>
			</div>


      <div class="add-card-btn" @click="toBindCard" style="margin-top:2rem" v-if="bind_length<4">
        <div class="plus-circle">
          <van-icon name="plus" />
        </div>
        <span class="btn-text">{{$t("setting.add_bank")}}</span>
      </div>

			<div class="tips-container">
				<van-icon name="info-o" class="tip-icon" />
				<p class="tip-text">{{$t("setting.bind_bank_tip")}}</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'BankInfo',
		data() {
			return {
				is_bind: false,
				bind_length: 0,
				bankInfo: [],
				userInfo: {}
			};
		},
		computed: {
			// 判断当前绑定的是否为虚拟货币（保留兼容性）
			isCrypto() {
				if (!this.bankInfo.length || !this.bankInfo[0] || !this.bankInfo[0].bankinfo) return false;
				const info = this.bankInfo[0].bankinfo.toUpperCase();
				return info.includes('USDT') || info.includes('USDC') || info.includes('BTC') || info.includes('ETH');
			}
		},
		methods: {
			back() {
				window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/member');
			},
			// 判断单张卡片是否为虚拟货币
			isCryptoCard(card) {
				if (!card || !card.bankinfo) return false;
				const info = card.bankinfo.toUpperCase();
				return info.includes('USDT') || info.includes('USDC') || info.includes('BTC') || info.includes('ETH');
			},
			// 判断是否为排除字段
			isExcludedField(key) {
				const excluded = ['create_time', 'fhnumber', 'id', 'uid', 'type', 'update_time', 'bankfenhang', 'realname'];
				return excluded.includes(key);
			},
			// 获取字段标签
			getFieldLabel(card) {
				return card.type===1?this.$t("setting.band_name_tip"):card.type===2?this.$t("setting.wallet_address"):card.type===3?this.$t("setting.receiver"):this.$t("setting.receiver");
			},
			// 格式化字段值
			formatFieldValue(key, value) {
				if (!value) return '';
				// 银行卡号格式化
				if (key === 'bankid') {
					return this.isCryptoCard(this.bankInfo.find(c => c.bankid === value)) ? this.formatCryptoAddress(value) : this.formatBankNo(value);
				}
				return value;
			},
			// 格式化银行卡号：显示前后4位，中间隐藏并隔开
			formatBankNo(no) {
				if (!no) return '';
				const str = no.toString().replace(/\s/g, '');
				return str.replace(/^(\d{4})\d+(\d{4})$/, "$1 **** **** $2");
			},
			// 格式化钱包地址：显示前6位和后4位，中间省略号
			formatCryptoAddress(address) {
				if (!address) return '';
				if (address.length > 12) {
					return address.substring(0, 6) + ' **** **** ' + address.substring(address.length - 4);
				}
				return address;
			},
			// 获取用户信息并校验提款密码
			getUserInfo() {
				return this.$http({
					method: 'get',
					url: 'user_info'
				}).then(res => {
					if (res.code === 200) {
						this.userInfo = res.data;
						if (!res.data.paypassword) {
							this.$toast(this.$t("my.please_set_withdraw_pwd"));
							this.$router.push("/setnewPayPassword");
							return false;
						}
						return true;
					} else {
						this.$toast(res.msg);
						return false;
					}
				});
			},
			// 获取银行卡/钱包信息
			getUserBankInfo() {
				this.$http({
					method: 'get',
					url: 'user_get_bank'
				}).then(res => {
					if (res.code === 200) {
						if (res.data.is_bank) {

              this.bind_length = res.data.info.length

							this.is_bind = true;
							this.bankInfo = res.data.info;
						} else {
							this.is_bind = false;
						}
					}
				});
			},
			toBindCard() {
				if (!this.userInfo.name) {
					this.$toast(this.$t("setting.set_name_bank"));
					this.$router.push("/Setname");
					return;
				}
				this.$router.push('/BindCard');
			}
		},
		async created() {
			const token = localStorage.getItem('token');
			if (!token) {
				this.$router.push('/Login');
			} else {
				const hasPassed = await this.getUserInfo();
				if (hasPassed) {
					this.getUserBankInfo();
				}
			}
		}
	};
</script>

<style lang="less" scoped>
	.bank-page { min-height: 100vh; background-color: #f8f9fa; }

	/* ----- 替换这里开始 ----- */
	::v-deep .van-nav-bar--fixed {
		/* 这里可以换成你想要的纯色，比如 background: #90298a !important; */
		background: linear-gradient(90deg, #7e5678, #a17e96) !important;
	}

	.custom-nav {
		background: linear-gradient(90deg, #7e5678, #a17e96) !important;
		::v-deep .van-nav-bar__content {
			background: transparent !important;
			height: 88px;
		}
		::v-deep .van-nav-bar__title {
			color: #fff !important;
			font-weight: 500;
			font-size: 32px;
		}
		::v-deep .van-icon {
			font-size: 40px !important;
		}
	}
	/* ----- 替换这里结束 ----- */

	.wrapper { padding: 40px 32px; }

	.bank-list {
		display: flex;
		flex-direction: column;
		gap: 24px;
	}

	.add-card-btn {
		height: 280px; background-color: #fff; border: 4px dashed #ccd0d7;
		border-radius: 20px; display: flex; flex-direction: column;
		align-items: center; justify-content: center; color: #7e5678; transition: all 0.2s;
		&:active { background-color: #f0f0f0; transform: scale(0.98); }
		.plus-circle { width: 80px; height: 80px; background: rgba(126, 86, 120, 0.1); border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 45px; margin-bottom: 20px; }
		.btn-text { font-size: 30px; font-weight: 500; }
	}

	/* 默认银行卡样式（紫红色系） */
	.bank-card-view {
		position: relative; height: 300px; background: linear-gradient(135deg, #7e5678 0%, #4a3146 100%);
		border-radius: 24px; padding: 40px; color: #fff; box-shadow: 0 15px 35px rgba(74, 49, 70, 0.3); overflow: hidden;
		transition: all 0.3s ease;

		.card-pattern { position: absolute; top: -40px; right: -40px; width: 280px; height: 280px; background: rgba(255, 255, 255, 0.05); border-radius: 50%; }
		.card-content { position: relative; z-index: 1; height: 100%; display: flex; flex-direction: column; justify-content: space-between; }
		.card-header { display: flex; align-items: center; .bank-logo { font-size: 50px; margin-right: 20px; opacity: 0.9; } .bank-name { font-size: 34px; font-weight: 600; letter-spacing: 1px; } .card-type { font-size: 20px; opacity: 0.6; text-transform: uppercase; margin-top: 5px; } }
		.card-number { font-size: 42px; font-family: 'Courier New', Courier, monospace; letter-spacing: 4px; margin: 20px 0; text-shadow: 0 3px 6px rgba(0, 0, 0, 0.3); }
		.card-fields { display: flex; flex-wrap: wrap; gap: 16px; .field-item { display: flex; flex-direction: column; .field-label { font-size: 18px; opacity: 0.6; margin-bottom: 4px; } .field-value { font-size: 26px; font-weight: 500; } } }
		.card-footer { display: flex; justify-content: space-between; align-items: flex-end; .holder-info { .label { font-size: 20px; opacity: 0.5; display: block; margin-bottom: 8px; } .name { font-size: 32px; font-weight: 500; } } .chip { width: 65px; height: 45px; background: rgba(255, 255, 255, 0.15); border-radius: 8px; display: flex; flex-direction: column; justify-content: space-around; padding: 8px; span { display: block; height: 2px; background: rgba(255, 255, 255, 0.3); } } }
	}

	/* 虚拟货币卡片样式（蓝黑色系区分） */
	.bank-card-view.crypto-card {
		background: linear-gradient(135deg, #2b324d 0%, #1a1e2e 100%);
		box-shadow: 0 15px 35px rgba(26, 30, 46, 0.4);

		/* 隐藏传统的银行卡芯片 */
		.chip { display: none; }
	}

	.tips-container { margin-top: 40px; padding: 0 20px; display: flex; align-items: flex-start; .tip-icon { color: #969799; font-size: 32px; margin-right: 12px; margin-top: 4px; } .tip-text { font-size: 26px; color: #969799; line-height: 1.6; margin: 0; } }
</style>
